import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';
import { RolePermissions } from 'shared/domain';
import { NamePipe } from 'shared/util-common';

import { GuidelineOrigin, GuidelineState, User } from '@treetop/shared/model';

import { ButtonDirective } from '../button/button.directive';
import { ChipComponent } from '../chip/chip.component';
import { IconDirective } from '../icon/icon.directive';
import { TooltipDirective } from '../tooltip/tooltip.directive';

interface CardProperties {
  id: string;
  uniqueId: string;
  title: string;
  owner: User;
  editor: User;
  version: string;
  state?: GuidelineState;
  guidelineOrigin?: GuidelineOrigin;
  imageUrl?: string;
  linkUrl: string;
}

@Component({
  selector: 'tt-guideline-preview-card',
  standalone: true,
  imports: [
    RouterModule,
    TranslocoModule,
    NamePipe,
    ChipComponent,
    MatTooltipModule,
    MatIconModule,
    IconDirective,
    TooltipDirective,
    LowerCasePipe,
    ButtonDirective,
    NgxPermissionsModule,
  ],
  templateUrl: './guideline-preview-card.component.html',
  styleUrls: ['./guideline-preview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidelinePreviewCardComponent {
  @Input() public guideline: CardProperties;
  @Input() public showOwner = false;

  protected GuidelineState = GuidelineState;
  protected readonly permissions = RolePermissions;
  protected readonly GuidelineOrigin = GuidelineOrigin;
}
